<template>
  <div
    class="edit-panel-header"
    :class="{'is-static-header': isSingleHeader}"
  >
    <span v-if="isSingleHeader" class="edit-panel-header__text">{{ $i18nPresenter.t(activeTabHeader) }}</span>

    <ActiveTab v-else :showingAudioTab="showingAudioTab" />
    <aha-icon
      name="close"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      class="edit-panel-header__close-button"
      @click="setRightNavActiveTabAction('')"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { EVENT_CATEGORIES_BY_ROUTE_NAME } from '@/constant/routes'
import utils from '@/util'

// components
import ActiveTab from '@/components-v2/presentation-editor/side-right/ActiveTab.vue'

export default {
  components: {
    ActiveTab,
  },
  props: {
    showingAudioTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('rightNav', ['activeTabHeader', 'isSingleHeader']),
    ...mapGetters('rightPanelContainer', ['isTabAudioSlideActive', 'isTabAudioPresentationActive', 'rightPanelContainerActiveTabs']),

    ...mapState({
      slideActive: (state) => state.slideActive,
    }),

    isHeaderActive() {
      return !this.isSingleHeader && this.isTabAudioSlideActive
    },
    isHeaderDisabled() {
      return !this.isSingleHeader && this.isAudioTabDisabled
    },
    isContentSlide() {
      return this.slideActive.type === 'freestyle'
    },
  },
  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),
    ...mapActions('rightPanelContainer', ['setRightPanelContainerActiveTabAction']),

    activeAudioTab(tabName) {
      this.setRightPanelContainerActiveTabAction(tabName)
      const eventLabel = tabName === this.rightPanelContainerActiveTabs.TAB_AUDIO_SLIDE ? 'Slide' : 'Presentation'
      utils.trackGA4AndMixpanel('Audio Tab > Switch tab', {
        eventAction: 'Audio Tab > Switch tab',
        eventLabel,
        eventCategory: EVENT_CATEGORIES_BY_ROUTE_NAME[this.$route.name],
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        userId: this.currentUser.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';

.edit-panel-header {
  @apply fixed top-0 z-10 border-b border-base-30 bg-base-0;
  @apply px-4 rounded-tl-lg rounded-tr-lg;
  @apply flex items-end justify-between;
  width: 382px;
  height: 55px;
  &.is-static-header {
    @apply items-center;
  }
  .edit-panel-header__text {
    @apply font-bold text-base;
  }
  .edit-panel-header__close-button {
    @apply text-base-70 hover:text-primary-90;
    @apply cursor-pointer;
    @apply h-full;
  }
}
</style>
